import Dimensions from "./Dimessions";
import DynamicContentSimuilador from './DynamicContentSimuilador';
import DynamicContentArea from "./DynamicContentArea";
import DynamicTrip from "./trip";

import DinamicSmartRoutePreferences from "./DinamicSmartRoutePreferences";
import Autonomy from "./Autonomy";

export const Dynamics = {
    Dimensions,
    DynamicContentSimuilador,
    DynamicContentArea,
    DynamicTrip,
    DinamicSmartRoutePreferences,
    Autonomy,
};